/**
 * move elements around within widget
 */
(() => {
  const newsletter1 = document.querySelector('.newsletter-1');
  if (!newsletter1) return;

  const formWrapper = newsletter1.querySelector('.form-wrapper');
  const description = newsletter1.querySelector('.desc-wrapper');

  if (description && formWrapper) {
    formWrapper.append(description);
  }

  const emailField = newsletter1.querySelector('.form-group.group-subscr-email');
  if (emailField) {
    emailField.style.display = 'flex';
  }

  const nameField = newsletter1.querySelector('.form-group.group-subscr-name');
  if (nameField && emailField) {
    emailField.prepend(nameField);
  }
})();

/**
 * add form validation
 */
(() => {
  const newsletter1 = document.querySelector('.newsletter-1');
  if (!newsletter1) return;

  const submitButton = newsletter1.querySelector('.subscr-submit');

  if (submitButton) {
    submitButton.innerHTML = 'Subscribe';
    const allInputs = newsletter1.querySelectorAll('input');

    const validateForm = () => {
      let isValid = true;

      allInputs.forEach((input) => {
        if (!input.value.trim()) {
          isValid = false;
        }
      });

      return isValid;
    };

    // Function to update submit button state
    const updateSubmitButton = () => {
      const isValid = validateForm();
      submitButton.disabled = !isValid;

      // Add visual feedback
      if (isValid) {
        submitButton.style.cursor = 'pointer';
      } else {
        submitButton.style.cursor = 'not-allowed';
      }
    };

    // Add event listeners to all inputs
    allInputs.forEach((input) => {
      input.addEventListener('input', updateSubmitButton);
      input.addEventListener('blur', updateSubmitButton);
    });

    // Prevent form submission if validation fails
    const form = newsletter1.querySelector('form') || newsletter1;
    form.addEventListener('submit', (e) => {
      if (!validateForm()) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    });

    updateSubmitButton();
  }
})();

/**
 * Remove the row class from the newsletter-background-image div
 * Create an h4 and insert it inside the direct col
 */
(() => {
  const newsletterBackgroundImage = document.querySelector('.newsletter-1 .newsletter-background-image');
  newsletterBackgroundImage?.classList.remove('row');

  const col = newsletterBackgroundImage?.querySelector(':scope > .col');
  const h4 = document.createElement('h4');
  h4.innerHTML = 'Keep me Updated';
  col?.prepend(h4);
})();
